module.exports = __webpack_public_path__ + "img/4b78dd31e641c8d036b092a42d27e2f3.png";